const styles = () => ({
  tabBody: { margin: '20px 0' }
});

export default styles;
